import { render, staticRenderFns } from "./userFeedback.vue?vue&type=template&id=585f1afa"
import script from "./userFeedback.vue?vue&type=script&lang=js"
export * from "./userFeedback.vue?vue&type=script&lang=js"
import style0 from "./userFeedback.vue?vue&type=style&index=0&id=585f1afa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports